<template>
    <div>
        <edit-category-modal
            v-model="editCategoryDialog"
            :modelProp="categorySelected"
            @successful-category-save="refreshCategoryData"
            @successful-category-delete="refreshCategoryData"
            :constants="constants"
        ></edit-category-modal>

        <internal-header heading="Manage Categories" :show-button="true" :button-link="addCategoryItem" button-text="Add Category" />
        <div class="tw-flex tw-gap-3 tw-mt-2">
            <div class="tw-w-1/3">
                <v-text-field
                    v-model="search"
                    label="Search Categories"
                    outlined
                    dense
                    append-icon="mdi-magnify"
                    clearable
                ></v-text-field>
            </div>
            <v-text-field
                v-model="filters.priority"
                label="Priority"
                outlined
                dense
                clearable
            ></v-text-field>
            <v-select
                v-model="filters.department"
                :items="getDepartments"
                label="Department"
                outlined
                dense
                clearable
            ></v-select>
            <v-select
                v-model="filters.display_website"
                :items="yesNoList"
                label="Website"
                outlined
                dense
                clearable
            ></v-select>
        </div>
        <smart-table
            id="categories_list"
            class="row-pointer"
            endpoint="categories.list"
            :headers="headers"
            :search="search"
            :multi-sort="true"
            :items-per-page="20"
            :display_fields="displayed_column_names"
            :footer-props="{
                'items-per-page-options': [5, 10, 20, 30]
            }"
            flat
            @click:row="showCategoryItem"
            ref="categories_list"
        >
            <template v-slot:item.abbreviation="{ isMobile, item, header, value, index}">
                {{ item.priority }}
            </template>
            <template v-slot:item.abbreviation="{ isMobile, item, header, value, index}">
                {{ item.abbreviation }}
            </template>
            <template v-slot:item.name="{ isMobile, item, header, value, index}">
                {{ item.name }}
            </template>
            <template v-slot:item.id="{ isMobile, item, header, value, index}">
                {{ item.id }}
            </template>
            <template v-slot:item.department="{ isMobile, item, header, value, index}">
                {{ item.department }}
            </template>
            <template v-slot:item.description="{ isMobile, item, header, value, index}">
                {{ item.description}}
            </template>
            <template v-slot:item.display_website="{ isMobile, item, header, value, index}">
                <strong>{{ findTextValueList(yesNoList, item.display_website) }}</strong>
            </template>
        </smart-table>
    </div>
</template>

<script>
    import SmartTable from "@/Generic/SmartTable";
    import AppLayout from "@/Layouts/AppLayout.vue";
    import EditCategoryModal from "@/Modals/EditCategoryModal"
    import InternalHeader from "@/Generic/InternalHeader";

    export default {
        name: "CategoriesIndex",
        layout: (h, page) => {
            return h(AppLayout, [
                page
            ])
        },
        components: {
            SmartTable,
            EditCategoryModal,
            InternalHeader,
        },
        remember: {
            data: [
                'items'
            ]
        },
        props: {
            'constants': {
                type: Object,
                required: false,
                default: function () {
                    return undefined
                }
            },
        },
        data() {
            return {
                search: null,
                editCategoryDialog: false,
                categorySelected: {},
                filters: {
                    priority: undefined,
                    department: undefined,
                    display_website: undefined,
                },
                yesNoList: [
                    {text: 'Yes', value: '1'},
                    {text: 'No', value: '0'},
                ]
            }
        },
        computed: {
            headers() {
                return [
                    {value: 'priority',                     text: 'Priority',                   align: `start`, sortable: true,    filterable: true,  search: this?.filters?.priority, optional: false, },
                    {value: 'abbreviation',                 text: 'Abbreviation',               align: `start`, sortable: true,    filterable: true,  optional: false, },
                    {value: 'name',                         text: 'Category Name',              align: `start`, sortable: true,    filterable: true,  optional: false, },
                    {value: 'id',                           text: 'Category ID',                align: `start`, sortable: true,    filterable: true,  optional: false, },
                    {value: 'department',                   text: 'Department',                 align: `start`, sortable: true,    filterable: true,  search: this?.filters?.department, optional: false, },
                    {value: 'description',                  text: 'Description',                align: `start`, sortable: true,    filterable: true,  optional: false, },
                    {value: 'display_website',              text: 'Website',                    align: `start`, sortable: true,    filterable: true,  search: this?.filters?.display_website, optional: false, },
                ]
            },
            displayed_column_names() {
                let headers_to_display = this.headers.filter(header => this.should_column_be_displayed(header.value))
                return headers_to_display.map(header => header.value)
            },
            getDepartments() {
                return Object.values(this.constants.TITLE_FUNCTION_DEPARTMENTS)
            },
        },
        methods: {
            should_column_be_displayed(column) {
                let required_headers = ['priority', 'abbreviation', 'name', 'id', 'department', 'description', 'display_website']
                return required_headers.includes(column)
            },
            findTextValueList(list, value) {
                return list.find(item => item.value == value)?.text
            },
            refreshCategoryData() {
                this.$refs.categories_list.refreshList()
            },
            showCategoryItem(item) {
                this.categorySelected = item
                this.editCategoryDialog = true
            },
            addCategoryItem() {
                this.categorySelected = null
                this.editCategoryDialog= true
            },
        }
    }
</script>

<style >
.row-pointer tbody tr {
    cursor: pointer;
}
</style>
